import { render } from "./UiPropSqlEditor.vue?vue&type=template&id=0e5f19b4"
import script from "./UiPropSqlEditor.vue?vue&type=script&lang=js"
export * from "./UiPropSqlEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__